define.alias("shared/components/shared/social/refresh-profile", "media/components/shared/social/refresh-profile");